import {
  ADD_FEATURE_LAYER_TO_MAP,
  REMOVE_FEATURE_LAYER_FROM_MAP,
} from './actionTypes';

export const addFeatureLayerToMap = (layer) => {
  return {
    type: ADD_FEATURE_LAYER_TO_MAP,
    payload: layer,
  };
};

export const removeFeatureLayerFromMap = (layer) => {
  return {
    type: REMOVE_FEATURE_LAYER_FROM_MAP,
    payload: layer,
  };
};
